import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { getVerticalOverride } from './verticalOverride';

export const getBaseURL = () => {
  // Check if we're on Firebase hosting or production domain
  if (window.location.hostname.includes('web.app') || 
      window.location.hostname.includes('firebaseapp.com') ||
      window.location.hostname.includes('localytics.co')) {
    
    // If URL contains staging, use staging API
    if (window.location.hostname.includes('staging')) {
      return 'https://localytics-platform-staging-e12f3ee1f38b.herokuapp.com';
    }
    // If we're on production domain or production Firebase, use production API
    if (window.location.hostname.includes('production') || 
        window.location.hostname.includes('localytics.co')) {
      return 'https://localytics-platform-server-816445c97ee2.herokuapp.com';
    }
    // Default to staging for other Firebase environments
    return 'https://localytics-platform-staging-e12f3ee1f38b.herokuapp.com';
  }

  // Fallback to environment-based URLs
  switch(process.env.NODE_ENV) {
    case 'development':
      return 'http://localhost:8000';
    case 'staging':
      return 'https://localytics-platform-staging-e12f3ee1f38b.herokuapp.com';
    case 'production':
      return 'https://localytics-platform-server-816445c97ee2.herokuapp.com';
    default:
      // Default to staging if environment is not specified
      return 'https://localytics-platform-staging-e12f3ee1f38b.herokuapp.com';
  }
};

// Create a base axios config that can be imported by services
export const baseAxiosConfig = {
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json'
  }
};

/**
 * Create an authenticated axios instance with Firebase Bearer token
 * and vertical override interceptors applied automatically.
 */
export const authAxios = axios.create(baseAxiosConfig);

// Attach Firebase Bearer token to every request
authAxios.interceptors.request.use(async (config) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      config.headers = config.headers || {};
      // Don't overwrite if already set per-request
      if (!config.headers['Authorization']) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }
  } catch (e) {
    // Silently continue — endpoint will return 401 if token is required
  }
  return config;
});

/**
 * Add a request interceptor that appends the vertical override query param
 * when an agency owner has selected a different vertical to view.
 */
export function applyVerticalOverrideInterceptor(axiosInstance) {
  axiosInstance.interceptors.request.use((config) => {
    const override = getVerticalOverride();
    if (override) {
      config.params = config.params || {};
      // Only set if not already explicitly provided
      if (!config.params.vertical) {
        config.params.vertical = override;
      }
    }
    return config;
  });
  return axiosInstance;
}

// Apply vertical override to the shared authenticated instance
applyVerticalOverrideInterceptor(authAxios);